module.exports = __webpack_public_path__ + "img/SimteruLogo.829e941b.png";